import classNames from 'classnames';
import {Moment} from 'moment';
import React from 'react';

import {CalendarEntryTask} from 'calendar/CalendarConstants';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import {INDENT_SIZE} from 'notebook/notes/lists/ListConstants';

import CalendarActions from './CalendarActions';

interface Props {
  date: Moment;
  entryId: string;
  entryTask: CalendarEntryTask;
  isLoadingData: boolean;
}

export default class EntryTask extends React.Component<Props> {
  _handleChange(): void {
    CalendarActions.updateEntryTask(
      this.props.date,
      this.props.entryId,
      this.props.entryTask.notePartProvenanceId,
      !this.props.entryTask.completed
    );
  }

  override render(): JSX.Element {
    return (
      <label
        className={classNames('entryExcerpt-entryTask u-pointer', {
          'u-faded': this.props.entryTask.completed,
        })}
        style={{marginLeft: (this.props.entryTask.indentation - 1) * INDENT_SIZE}}
      >
        <input
          type="checkbox"
          checked={this.props.entryTask.completed}
          className="u-flex-none"
          disabled={this.props.isLoadingData}
          onChange={() => {
            this._handleChange();
          }}
        />
        <div
          className="u-small-spacing-left"
          // oxlint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: formatters.renderHTML(this.props.entryTask.text, this.props.entryTask.formats),
          }}
        />
      </label>
    );
  }
}
